// [init]

import Axios from "axios/index";
import _ from "lodash";

export default {


	namespaced: true,

	state: {},

	mutations: {},

	actions: {

		payPackage( { commit }, data ) {


			return new Promise (( resolve, reject ) => {
 
				const postData = {
					stripeToken: data.stripeToken,
					promocode: data.promocode,
				    picked : data.picked,
				    change : data.change,
				    promocode : data.promocode,
					price  : data.total    

				};


				global.axios.request({
					method: 'post',
					url: '/packages/' + data.packageID + '/pay',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
                    if(!_.isNil(data.jobID) && !_.isNil(data.promocode)) {
                        Axios
                            .post('calendar/create_event', {
                                jobId: data.jobID
                            })
                            .then(jobResponse => {
                                console.log(jobResponse)
                                resolve(response)
                            })
                            .catch(e => {
                                console.log(e)
                                resolve(response)
                            })

                    } else {
                        resolve(response);
                    }
				})
				.catch(error => reject( error ));

			});

		},

		payJob( { commit }, data ) {

			return new Promise (( resolve, reject ) => {

				const postData = {
					stripeToken: data.stripeToken,
					total: data.total,
					picked: data.picked,
					email : data.email,
					change : data.change,
					promocode : data.promocode,
					price  : data.pricecode,
					jobtype: data.jobtype,
					creditsUsed: data.creditsUsed
				};

				global.axios.request({
					method: 'post',
					url: '/jobs/' + data.jobID + '/commit',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
                    if(!_.isNil(data.jobID) && !_.isNil(data.promocode)) {
                        Axios
                            .post('calendar/create_event', {
                                jobId: data.jobID
                            })
                            .then(jobResponse => {
                                console.log(jobResponse)
                                resolve(response)
                            })
                            .catch(e => {
                                console.log(e)
                                resolve(response)
                            })

                    } else {
                        resolve(response);
                    }
					// resolve( response );
				})
				.catch(error => reject( error ));

			});

		}

	}

};


// WEBPACK FOOTER //
// ./src/custom/controllers/Payment.js